import { EmptyState } from '../components/EmptyState.js';

export function MemoryPage() {
  return (
    <EmptyState
      title="Memory"
      body="Cross-repo team memory (resolved findings + rule corrections) — tracked under the existing team_memory plan."
    />
  );
}